import { Component } from '@angular/core';
import { AppData } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'yumzy-review-panel';

  constructor(private appData: AppData) {

  }
}
